import { DashboardPageStateModel } from "src/app/dashboard/dashboard.state";
import { AvailabilityType } from "../../../interfaces/availability-type.interface";
import { WorkerAvailabilityGrouped } from "../../../interfaces/worker-availability.interface";

export class AvailabilityStateModel extends DashboardPageStateModel {
	workersAvailability: Array<WorkerAvailabilityGrouped>;
	availabilityTypes: Array<AvailabilityType>;
	totalWorkers: number;
	loadingTypes: boolean;
}